import { DEFAULT_SORT_CATEGORY, SortOrder } from 'hooks/use-stored-sorts'
import { ServicesGroup } from 'types/api/policies/reliability-report'
import { getLightMuiBackgroundColor } from 'utils/colors'

/**
 * Types
 */
export interface SortParam {
  [key: string]: {
    field: string
    order: SortOrder
  }
}

export type GroupByOption = {
  value: ServicesGroup
  label: string
}

export type GroupByOptions = {
  [key in ServicesGroup]: GroupByOption
}

/**
 * Constants
 */
export const DASHBOARD_LIST_ITEMS_PER_PAGE = 10
export const SERVICE_CARD_LINE_CHART_HEIGHT = 80
export const SERVICE_CARD_LINE_CHART_WIDTH = 230

export const DEFAULT_DASHBOARD_LIST_SORTS: Record<ServicesGroup, SortParam> = {
  [ServicesGroup.NONE]: {
    [DEFAULT_SORT_CATEGORY]: {
      field: 'score',
      order: 'desc'
    }
  },
  [ServicesGroup.TEAM]: {
    [DEFAULT_SORT_CATEGORY]: {
      field: 'avgScore',
      order: 'desc'
    }
  }
}

export const DASHBOARD_LIST_GROUP_BY_OPTIONS: GroupByOptions = {
  [ServicesGroup.NONE]: {
    value: ServicesGroup.NONE,
    label: 'None'
  },
  [ServicesGroup.TEAM]: {
    value: ServicesGroup.TEAM,
    label: 'Team'
  }
}

export const DEFAULT_DASHBOARD_LIST_SORT_ORDERS: Record<
  ServicesGroup,
  Record<string, SortOrder>
> = {
  [ServicesGroup.NONE]: {
    score: 'desc',
    serviceName: 'asc',
    lastModified: 'desc'
  },
  [ServicesGroup.TEAM]: {
    avgScore: 'desc'
  }
}

export const DASHBOARD_LIST_SORT_MENU_ITEMS = {
  [ServicesGroup.NONE]: [
    { value: 'score', label: 'Score' },
    { value: 'serviceName', label: 'Name' },
    { value: 'lastModified', label: 'Modified Date' }
  ],
  [ServicesGroup.TEAM]: [{ value: 'avgScore', label: 'Average Score' }]
}

/**
 * Utility functions
 */

export function getServiceNotInTeamTooltipMessage(teamName) {
  return `This service's details can only be accessed by members of ${teamName}`
}

export function getBackgroundColorFromReliabilityScore(
  muiTheme,
  reliabilityScore
) {
  if (reliabilityScore >= 75) {
    return getLightMuiBackgroundColor(muiTheme.palette.success.light)
  }

  if (reliabilityScore < 75 && reliabilityScore >= 50) {
    return getLightMuiBackgroundColor(muiTheme.palette.warning.light)
  }

  return getLightMuiBackgroundColor(muiTheme.palette.error.light)
}
